/**
 * @flow
 * @relayHash 753691295e559fe24b79cdc68fc06c2a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProjectPhaseUpdateInput = {|
  id: string,
  name: string,
  color: string,
|};
export type UpdateProjectPhaseMutationVariables = {|
  data: ProjectPhaseUpdateInput
|};
export type UpdateProjectPhaseMutationResponse = {|
  +updateProjectPhase: {|
    +id: string
  |}
|};
export type UpdateProjectPhaseMutation = {|
  variables: UpdateProjectPhaseMutationVariables,
  response: UpdateProjectPhaseMutationResponse,
|};
*/


/*
mutation UpdateProjectPhaseMutation(
  $data: ProjectPhaseUpdateInput!
) {
  updateProjectPhase(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "ProjectPhaseUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateProjectPhase",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "ProjectPhaseModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateProjectPhaseMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateProjectPhaseMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateProjectPhaseMutation",
    "id": null,
    "text": "mutation UpdateProjectPhaseMutation(\n  $data: ProjectPhaseUpdateInput!\n) {\n  updateProjectPhase(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5c2532ec43378f571f3cb2b875a771c7';
module.exports = node;
